import React from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';
export function HeroSection() {
  const {
    t
  } = useLanguage();
  const scrollToServices = () => {
    const element = document.getElementById('servicios');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="inicio" className="relative min-h-[80vh] sm:min-h-[85vh] md:min-h-screen flex items-center justify-center bg-[#1a365d] overflow-hidden p-[10px]" data-id="element-115">
      <img src="https://cdn.magicpatterns.com/uploads/s7bBSy7Yeazme3YY8f9fbX/foto_402x874.png" alt="" loading="eager" decoding="async" fetchPriority="high" sizes="100vw" className="absolute inset-0 m-[10px] w-[calc(100%-20px)] h-[calc(100%-20px)] max-w-none object-cover opacity-40 object-[center_20%] sm:object-[center_25%] md:object-[center_30%] lg:object-center" data-id="element-116" />

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28 md:py-32 text-center" data-id="element-117">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-118">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-4" data-id="element-119">
            Jesús Silva
          </h1>
          <p className="text-2xl md:text-3xl text-[#d97706] font-semibold mb-4" data-id="element-120">
            {t('Tu tranquilidad es mi prioridad', 'Your peace of mind is my priority')}
          </p>
          <p className="text-xl text-gray-200 mb-2" data-id="element-121">
            {t('Agente de Seguros de Protección Integral', 'Comprehensive Protection Insurance Agent')}
          </p>
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-lg md:text-xl text-gray-100 max-w-3xl mx-auto mb-10 leading-relaxed" data-id="element-122">
          {t('Te ayudo a encontrar la protección adecuada para ti, tu familia y tus seres queridos. Planes de salud, seguros de vida, accidentes y Medicare — todo adaptado a tus necesidades y presupuesto.', 'I help you find the right protection for you, your family, and your loved ones. Health plans, life insurance, accident insurance, and Medicare — all tailored to your needs and budget.')}
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} onClick={scrollToServices} className="bg-[#d97706] text-white px-8 py-4 rounded-lg text-lg font-semibold hover:bg-[#b45309] transition-all transform hover:scale-105 shadow-lg" data-id="element-123">
          {t('Conoce Mis Servicios', 'Explore My Services')}
        </motion.button>
      </div>
    </section>;
}